import Card from '@mui/material/Card'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

export const ErrorPage = () => {
    return (
        <Card
            sx={{
                height: `calc(100dvh)`,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}>
            <>
                <Typography variant="h4" sx={{ textAlign: 'center', mt: 2 }}>
                    Страница не найдена
                </Typography>
                <Link sx={{ textAlign: 'center', mt: 4 }} href="/">
                    На главную
                </Link>
            </>
        </Card>
    )
}
